import React from "react";
import {
  SEO,
  PageLayout,
  VerticalCarousel,
  componentIterator,
  Image,
  OutboundLink,
  InternalLink,
  DynamicScript,
  Background,
  ContinuousScroll,
  PatternedImageRow,
  BasicCarousel,
  Review,
} from "@bluefin/components";
import { Grid, List, Button } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import { getComponentFiles } from "../utils/utils";

export default class IndexPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
        />
        <PageLayout className={"home-page"}>
          <div className={"hero-images-container"}>
            <VerticalCarousel
              size={1}
              pageIndicatorIcon={"square outline"}
              orientation={"right"}
              items={componentIterator({
                iterator: getComponentFiles({
                  components: fishermanBusinessWebsitePage.components,
                  componentName: "HeroElement",
                }),
                component: <Image className={"image"} />,
                propMap: { src: "__all__" },
              })}
            />
          </div>
          <Grid
            stackable={true}
            className={"component-section-container home-about-container"}
            verticalAlign={"middle"}
            textAlign={"center"}
          >
            <Grid.Column width={8} textAlign={"center"}>
              <h2>WELCOME TO ISLAND LAVA JAVA</h2>
              <h2>COME DINE WITH US!</h2>
              <p>
                We believe in community, creativity & aloha! Starting with our
                scratch-kitchen Bistro serving Kailua-Kona since 1994, then
                introducing our sister location in Waikoloa Village - we
                specialize in fresh, local, organic and sustainable food.
                Proudly featuring estate grown 100% Kona coffee, freshly
                squeezed juices, scratch creations, house-baked desserts &
                pastries.
              </p>
              <List
                items={[
                  "We love our ‘āina and want to share our aloha with you!...E komo mai! Come, join your friends",
                  "at Island Lava Java – we look forward to seeing you!",
                  "A hui hou koke iā ‘oe!",
                ]}
              />
            </Grid.Column>
          </Grid>
          <Grid
            stackable={true}
            verticalAlign={"top"}
            textAlign={"left"}
            centered={true}
            column={"2"}
          >
            <Grid.Row stretched={true}>
              <Grid.Column width={8} textAlign={"center"}>
                <Image
                  size={"large"}
                  centered={true}
                  src={
                    "https://fisherman.gumlet.io/public/6c678122-996e-4d13-bed0-1ccc87b3452b/Screenshot_2023-10-07_072303.png"
                  }
                />
                <div className={"home-ctas-container"}>
                  <Button
                    primary={true}
                    to={"https://www.toasttab.com/island-lava-java/v3"}
                    as={OutboundLink}
                  >
                    Order Online
                  </Button>
                  <Button primary={true} to={"/kona-menu/"} as={InternalLink}>
                    Menu
                  </Button>
                </div>
                <DynamicScript
                  src={
                    "https://www.opentable.com/widget/reservation/loader?rid=52420&type=standard&theme=standard&color=1&dark=false&iframe=true&domain=com&lang=en-US&newtab=false&ot_source=Restaurant%20website&cfe=true"
                  }
                />
              </Grid.Column>
              <Grid.Column width={8} textAlign={"center"}>
                <Image
                  size={"large"}
                  centered={true}
                  src={
                    "https://fisherman.gumlet.io/public/6c678122-996e-4d13-bed0-1ccc87b3452b/Screenshot_2023-10-07_072431.png"
                  }
                />
                <div className={"home-ctas-container"}>
                  <Button
                    primary={true}
                    to={
                      "https://www.toasttab.com/lava-java-waikoloa-68-1845-waikoloa-rd"
                    }
                    as={OutboundLink}
                  >
                    Order Online
                  </Button>
                  <Button
                    primary={true}
                    to={"/waikoloa-menu/"}
                    as={InternalLink}
                  >
                    Menu
                  </Button>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <div className={"image-gallery-container"}>
            <Background
              columns={1}
              stackable={true}
              className={"images-background"}
            >
              <Background.Pattern type={"CIRCLE"}>
                <ContinuousScroll
                  className={"patterned-images-container-scroll"}
                >
                  <PatternedImageRow
                    containerAs={ContinuousScroll.Item}
                    images={getComponentFiles({
                      components: fishermanBusinessWebsitePage.components,
                      componentName: "ImageCollection",
                    })}
                    imageSizePatterns={[
                      { width: 50, height: 83, alignment: "middle" },
                    ]}
                  />
                </ContinuousScroll>
              </Background.Pattern>
            </Background>
          </div>
          <div className={"reviews-container"}>
            <BasicCarousel
              size={3}
              pageIndicatorIcon={null}
              mobile={{ arrowsPosition: "top" }}
              items={componentIterator({
                iterator: fishermanBusiness.reviews,
                component: <Review as={"horizontalItem"} charLimit={200} />,
                propMap: { author: "author", text: "text" },
              })}
            />
          </div>
          <Grid
            stackable={true}
            className={"component-section-container"}
            verticalAlign={"middle"}
            textAlign={"center"}
          >
            <Grid.Column width={16} textAlign={"center"}>
              <Button
                primary={true}
                size={"large"}
                to={
                  "https://form.jotform.com/The_Avocado_Group/photographvideo-release-form"
                }
                as={OutboundLink}
              >
                Photo Release Form
              </Button>
            </Grid.Column>
          </Grid>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      reviews {
        author
        text
        link
      }
    }
    fishermanBusinessWebsitePage(pageType: { eq: "Home" }) {
      title
      description
      components {
        fastId
        componentIdentifier
        order
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
          _id
        }
      }
    }
  }
`;
